import {
  Card, CardBody, CardFooter,
} from "@heroui/react";
import type { CSSProperties, FC } from "react";
import type { IComponentBaseProps } from "@/shared/config";
import type { IAdvantages } from "../config";

/**
 * Блок преимуществ
 * @constructor
 */
export const Advantages: FC<IAdvantages & IComponentBaseProps> = ({
  title,
  subtitle,
  advantagesItems = [],
}) => {

  const headingCompact = {
    "--heading-line-height": "1",
  } as CSSProperties;

  return (
    <section id={"advantages"} className={"flex flex-col items-center text-center mx-auto gap-[7rem] mobile:gap-6 mobile:max-w-100"}>
      <div className={"flex flex-col items-center text-center max-w-200 mobile:max-w-100 mx-auto gap-5 mobile:gap-4"}>
        <h2 style={headingCompact} className={"h2"}>
          {title}
        </h2>
        <p className={"subtitle"}>{subtitle}</p>
      </div>
      <ul className={"grid grid-cols-12 mobile:grid-cols-1 mobile:gap-2 mobile:max-w-100 gap-4"}>
        {advantagesItems.map((item, index) => (<li key={index} className={item.utilClasses}>
          <Card className={"relative overflow-hidden rounded-[3rem] bg-codGray h-full min-h-100 mobile:min-h-60 mobile:h-60 "}>
            <CardBody className={"p-0 relative h-full overflow-hidden"}>
              <picture className={"block w-full h-full"}>
                <source srcSet={item.img.mobile} media={"(max-width: 768px)"} />
                <img
                  draggable={false}
                  src={item.img.desktop}
                  alt={item.img.alt}
                  className={"block w-full h-auto object-cover object-top"}
                  loading={"lazy"}
                />
              </picture>
            </CardBody>

            <CardFooter className={"absolute bottom-0 left-0 mobile:px-6 mobile:pb-6 px-10 pb-9 flex-col items-start text-white pt-0 gap-3.5 rounded-none mt-auto z-10"}>
              <h6 className={"text-left h6 font-semibold"}>{item.title}</h6>
              <p className={"text-left text text-white-70"}>{item.desc}</p>
            </CardFooter>
          </Card>
        </li>))}
      </ul>
    </section>
  );
};
